import API from 'API'

export const START_LOAD_STATIONS_FOR_MAP = 'START_LOAD_STATIONS_FOR_MAP'
export const SUCCESS_LOAD_STATIONS_FOR_MAP = 'SUCCESS_LOAD_STATIONS_FOR_MAP'

export const loadStationForMap =
  (forceReload = false) =>
  (dispatch, getState) => {
    const {map} = getState()
    const hasStations = Array.isArray(map?.spp) && Array.isArray(map?.wpp)
    const isAlreadyLoaded = hasStations && map.spp.length > 0 && map.wpp.length > 0

    if (!forceReload && (map?.isLoading || map?.isLoaded || isAlreadyLoaded)) {
      return
    }

    dispatch({type: START_LOAD_STATIONS_FOR_MAP})
    API.getStationsForMap()
      .then(({data}) => {
        dispatch({
          type: SUCCESS_LOAD_STATIONS_FOR_MAP,
          data,
        })
      })
      .catch(() => {
        console.error('LOAD_STATIONS_FOR_MAP')
      })
  }
